import * as RadixSelect from '@radix-ui/react-select'
import * as React from 'react'

import { cn } from '~/styled'

import { Text } from '../text/Text'

type SelectMenuLabelProps = React.ComponentProps<typeof RadixSelect.Label>

export const SelectMenuLabel = ({
  className,
  ...props
}: SelectMenuLabelProps) => (
  <Text
    as={RadixSelect.Label}
    size="sm"
    className={cn('p-2', 'mb-1', 'text-text-subtle', className)}
    {...props}
  />
)

SelectMenuLabel.displayName = 'SelectMenuLabel'
